module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA8klEQVQokX3RsSuFURzG8Y/bm+ySKMp/4F8QokiyMIiukoX1tdhsjBaKMlmUDJKIe9VNmUhs/gJlNXi79xr83np7i7OczvN8n9/pOadj+ih7R4oz/6857CZYxym6cPIHvIADzCe4wgzO0YnjEryEPcyiloRYwxQu4qb90FexE14DksKkBiZwGaEM25jEYw4l2MQhPsMYwzXaGMVTsN1YSTCMO4zjI4CRgF5j74khbxUs4hl19BXAHO6Nji9YrqCJanSoY7DQqz+0h2CalTBaWMMN7jGEgZh8G16r/EptbOArQpnf30/DUw7koRTfcd4q+X4AxYU71loQrAYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/images/open_icon_blue.png
// module id = 6QkT
// module chunks = 2